import { Box, Radio } from "@mui/material";
import { IconTrash } from "@tabler/icons-react";
import Button from "../../../../components/ui/Button";
import Text from "../../../../components/ui/Text";

export const SavedCards = ({
  savedPaymentMethods,
  selectedPaymentMethodId,
  setSelectedPaymentMethodId,
  handleOpenDeleteDialog,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", mb: 2 }}>
      {savedPaymentMethods.map(({ payment_method_id, card }) => (
        <Box
          key={payment_method_id}
          sx={{
            display: "flex",
            alignItems: "center",
            mb: 2,
            border:
              selectedPaymentMethodId === payment_method_id
                ? "1px solid #1890FF"
                : "1px solid #E5E5E5",
            borderRadius: "8px",
            backgroundColor:
              selectedPaymentMethodId === payment_method_id
                ? "#F0F8FF"
                : "white",
            position: "relative",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#F8F9FA",
            },
          }}
          onClick={() => {
            setSelectedPaymentMethodId(payment_method_id);
          }}
        >
          {/* Radio button indicator */}
          <Radio
            checked={selectedPaymentMethodId === payment_method_id}
            onChange={() => setSelectedPaymentMethodId(payment_method_id)}
            sx={{
              color: "#D9D9D9",
              "&.Mui-checked": {
                color: "#1890FF",
              },
              "& .MuiSvgIcon-root": {
                fontSize: 20,
              },
            }}
          />
          {/* Card details */}
          <Box sx={{ flex: 1 }}>
            <Text
              variant="paragraph"
              sx={{ fontSize: "14px", fontWeight: 500 }}
            >
              Pay with{" "}
              {card.brand?.charAt(0).toUpperCase() + card.brand?.slice(1)}{" "}
              Ending {card.last4}
            </Text>
          </Box>
          <Button
            variant="tertiary"
            size="small"
            onClick={() => handleOpenDeleteDialog(payment_method_id)}
            sx={{
              mr: 1,
              color: "#A1A1A1",
              p: 0,
              borderRadius: "50%",
              minWidth: "32px",
              height: "32px",
              "&:hover": { color: "#FF4D4F" },
            }}
          >
            <IconTrash size={16} />
          </Button>
        </Box>
      ))}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border:
            selectedPaymentMethodId === "new_card"
              ? "1px solid #1890FF"
              : "1px solid #E5E5E5",
          borderRadius: "8px",
          backgroundColor:
            selectedPaymentMethodId === "new_card" ? "#F0F8FF" : "white",
          position: "relative",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#F8F9FA",
          },
        }}
        onClick={() => {
          setSelectedPaymentMethodId("new_card");
        }}
      >
        {/* Radio button indicator */}
        <Radio
          checked={selectedPaymentMethodId === "new_card"}
          onChange={() => setSelectedPaymentMethodId("new_card")}
          sx={{
            color: "#D9D9D9",
            "&.Mui-checked": {
              color: "#1890FF",
            },
            "& .MuiSvgIcon-root": {
              fontSize: 20,
            },
          }}
        />

        {/* Text */}
        <Box sx={{ flex: 1 }}>
          <Text variant="paragraph" sx={{ fontSize: "14px", fontWeight: 500 }}>
            Add a new card
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
